module.exports = __webpack_public_path__ + "img/AIQuizBanner.802575a0.png";